// Saved locations API — CRUD + Nominatim address-search proxy.
import { http } from "./http";
import type {
  LocationInput,
  LocationSearchHit,
  OkResponse,
  SavedLocation,
} from "./types";

export const locationsApi = {
  list: (signal?: AbortSignal) =>
    http.get<SavedLocation[]>("/locations", undefined, signal),
  get: (id: number, signal?: AbortSignal) =>
    http.get<SavedLocation>(`/locations/${id}`, undefined, signal),
  create: (body: LocationInput) =>
    http.post<SavedLocation>("/locations", body),
  update: (id: number, body: LocationInput) =>
    http.patch<SavedLocation>(`/locations/${id}`, body),
  remove: (id: number) => http.del<OkResponse>(`/locations/${id}`),
  /** Address autocomplete via the server-side Nominatim proxy. */
  search: (q: string, signal?: AbortSignal) =>
    http.get<LocationSearchHit[]>("/locations/search", { q }, signal),
};
